export const translations = {
	'You have unsaved content in the dashboard. You will lose the changes if you click Close. Click Cancel and save the changes if you want to keep the changes.':
		{
			no: 'Du har ulagret innhold i dashboardet. Du vil miste endringene om du klikker Lukk. klikk avbryt for å gå tilbake å lagre innstillingene om du vil beholde dem',
		},
};
